<form (ngSubmit)="submitForm()" [formGroup]="newTenantForm" class="new-tenant-form">
    <mat-form-field [ngClass]="{ 'valid-field': isFieldValid('tenantSlug')}">
        <mat-label id="label-tenant-slug">Tenant Slug</mat-label>
        <input matInput formControlName="tenantSlug" name="slug" id="new-tenant-slug-input" aria-labelledby="label-tenant-slug" />
        @if (hasRequiredError('tenantSlug')) {
            <mat-error>
                Tenant slug is required
            </mat-error>
        }
        @if (hasMinLengthError('tenantSlug')) {
            <mat-error>
                Slug should have at least 3 characters
            </mat-error>
        }
        @if (hasPatternError('tenantSlug')) {
            <mat-error>
                Slug can contain only letters and numbers
            </mat-error>
        }
        @if (tenantSlugAlreadyExists()) {
            <mat-error>
                Tenant slug already exists
            </mat-error>
        }
    </mat-form-field>
    @if (isFieldValid('tenantSlug')) {
        <mat-icon class="valid">done</mat-icon>
    }
    @if (isFieldInvalid('tenantSlug')) {
        <mat-icon class="invalid">error_outline</mat-icon>
    }
   

    <mat-form-field [ngClass]="{ 'valid-field': isFieldValid('tenantName')}">
        <mat-label id="label-tenant-name">Tenant Name</mat-label>
        <input matInput formControlName="tenantName" name="name" id="new-tenant-name-input" aria-labelledby="label-tenant-name" />
        @if (hasRequiredError('tenantName')) {
            <mat-error>
                Tenant name is required
            </mat-error>
        }
    </mat-form-field>
    @if (isFieldValid('tenantName')) {
        <mat-icon class="valid">done</mat-icon>
    }
    @if (isFieldInvalid('tenantName')) {
        <mat-icon class="invalid">error_outline</mat-icon>
    }
   

    <!-- Industry -->

    <mat-form-field [ngClass]="{ 'valid-field': isFieldValid('tenantIndustry')}">
        <mat-label id="label-tenant-industry">Tenant Industry</mat-label>
        <mat-select class="mat-primary" formControlName="tenantIndustry" name="tenantIndustry" id="new-tenant-industry-select" aria-labelledby="label-tenant-industry">
            @for (type of tenantIndustryTypes; track type) {
                <mat-option [value]="type">
                    {{ type }}
                </mat-option>
            }
        </mat-select>
        @if (hasRequiredError('tenantIndustry')) {
            <mat-error>
                Industry is required
            </mat-error>
        }
    </mat-form-field>
   

    <!-- Company Size -->

    <mat-form-field [ngClass]="{ 'valid-field': isFieldValid('tenantCompanySize')}">
        <mat-label id="label-company-size">Company Size</mat-label>
        <mat-select class="mat-primary" formControlName="tenantCompanySize" name="tenantCompanySize" id="new-tenant-company-size-select" aria-labelledby="label-company-size">
            @for (size of tenantSizes; track size) {
                <mat-option [value]="size">
                    {{ size }}
                </mat-option>
            }
        </mat-select>
        @if (hasRequiredError('tenantCompanySize')) {
            <mat-error>
                Company Size is required
            </mat-error>
        }
    </mat-form-field>
   

    <mat-form-field [ngClass]="{ 'valid-field': isFieldValid('tenantType')}">
        <mat-label id="label-tenant-type">Tenant Type</mat-label>
        <mat-select class="mat-primary" formControlName="tenantType" name="tenantType" id="new-tenant-type-select" aria-labelledby="label-tenant-type">
            @for (type of tenantTypes; track type.Value) {
                <mat-option [value]="type.Value">
                    {{type.Text || type.Value}}
                </mat-option>
            }
        </mat-select>
        @if (hasRequiredError('tenantType')) {
            <mat-error>
                Tenant type is required
            </mat-error>
        }
    </mat-form-field>
   

    <mat-form-field [ngClass]="{ 'valid-field': isFieldValid('permissionGroup')}">
        <mat-label id="label-permission-group">Tenant Group</mat-label>
        <mat-select class="mat-primary" formControlName="permissionGroup" id="new-tenant-group-select"
            name="tenantPermissionGroup" aria-labelledby="label-permission-group">
            @for (permissionGroup of tenantPermissionGroups; track permissionGroup.name) {
                <mat-option [value]="permissionGroup.name">
                    {{ permissionGroup.displayName }}
                </mat-option>
            }
        </mat-select>
        @if (hasRequiredError('permissionGroup')) {
            <mat-error>
                Tenant permission group is required
            </mat-error>
        }
    </mat-form-field>
   
    @if (hasEnvironmentField) {
        <mat-form-field [ngClass]="{ 'valid-field': isFieldValid('environmentId')}">
            <mat-label id="label-environment">Environment</mat-label>
            <mat-select class="mat-primary" formControlName="environmentId" id="new-tenant-environment-select"
                name="environmentId" aria-labelledby="label-environment">
                @for (environment of environments; track environment.Id) {
                    <mat-option [value]="environment.Id">
                        {{ environment.Name }}
                    </mat-option>
                }
            </mat-select>
            @if (hasRequiredError('environmentId')) {
                <mat-error>
                    Environment is required
                </mat-error>
            }
        </mat-form-field>
    }
   
    <div class="button-container">
        <button mat-raised-button [disabled]="!isSubmitButtonAvailable()" class="mat-accent submit-button" type="submit">{{ actionName }}</button>
    </div>
</form>